import firebase, {db, auth, fc} from './connection'

export default {
    createCheckout(payload) {
        let createCheckout = fc.httpsCallable('createCheckout');

        return createCheckout(payload)
                    .then(response => {
                        return {status: true, response: response.data};
                    })
                    .catch(error => {
                        return error;
                    });
    },

    getByPayment(sessionId) {
        let ref = db.collection('payments').where('session_id', '==', sessionId)

        return ref.get()
                .then(query => {
                    return {status: true, query: query}
                })
                .catch(error => {
                    return error;
                });
    },

    getAll() {
        let ref = db.collection('payments');

        return ref.get()
                .then(query => {
                    return {status: true, query: query}
                })
                .catch(error => {
                    return error;
                });
    },

    getLivestreamRegisteredUser(email) {
        let ref = db.collection('lsRegistered').doc(email);

        return ref.get()
                .then(doc => {
                    return {status: true, doc: doc}
                })
                .catch(error => {
                    return error;
                });
    },

    getProgramApplicationRegisteredUser(email) {
        let ref = db.collection('paRegistered').doc(email);

        return ref.get()
                .then(doc => {
                    return {status: true, doc: doc}
                })
                .catch(error => {
                    console.log(error)
                    return error;
                });
    },

    getSummercampApplicationRegisteredUser(email) {
        let ref = db.collection('smRegistered').doc(email);

        return ref.get()
                .then(doc => {
                    return {status: true, doc: doc}
                })
                .catch(error => {
                    return error;
                });
    }

}